import {TextAlignment} from '@volkswagen-onehub/components-core';
import React from 'react';
import BodyText from '../BodyText';
import CloseButtonSVG from '../CloseButtonSVG';
import Div from '../Div.styled';
import './Dialog.css';

const Dialog = ({
  isOpen,
  onClose,
  content,
  title,
}: {
  isOpen: boolean;
  onClose: () => void;
  content: string;
  title?: string;
}) => {
  return isOpen ? (
    <Div className="overlay">
      <Div className="dialog">
        <CloseButtonSVG
          onClick={onClose}
          style={{
            right: 16,
            position: 'absolute',
            top: 16,
          }}
          color="black"
        />
        <BodyText color="black" weight="700" align={TextAlignment.left}>
          {title}
        </BodyText>
        <BodyText color="black" align={TextAlignment.left}>
          {content}
        </BodyText>
      </Div>
    </Div>
  ) : (
    <></>
  );
};

export default Dialog;
